import React, { useState, useEffect, use } from 'react'
import PropTypes from 'prop-types'
import styles from './EmailReceipt.module.scss'
import { useDispatch } from 'react-redux'
import { submitEmail } from './ReceiptUtils'

const EmailReceipt = ({ order, paymentId })  => {
  const [emailInfo, setEmailInfo] = useState({ sFocused: false, isValid: true })

  const dispatch = useDispatch()
  const enterEmailRef = React.createRef()

  useEffect(() => {
    enterEmailRef.current.focus()
  }, [])

  const onEmailSubmit = () => {
    dispatch(submitEmail(emailInfo, order, paymentId, setEmailInfo))
  }

  const exclamation = !emailInfo.isValid && (
      <svg
        width="20"
        height="20"
        viewBox="0 0 32 32"
        style={{ marginRight: "17px "}}
      >
        <path
          fill="#E21E5C"
          fillRule="nonzero"
          d="M16 32c8.832 0 16-7.168 16-16S24.832 0 16 0 0 7.168 0 16s7.168 16 16 16zM14.4 8h3.2v9.6h-3.2V8zm0 12.8h3.2V24h-3.2v-3.2z"
        />
      </svg>
  )

const sendEmailButton = emailInfo.isValid && (
    <div className={styles.emailSubmit}>
      <div className={styles.emailSubmitButton} onClick={onEmailSubmit}>Send</div>
      </div>
  )

  const emailAccessory = emailInfo.isValid ? sendEmailButton : exclamation

  let emailMessage = <p className={styles.emailMessage}>Separate multiple emails with comma</p>
  if (!emailInfo.isValid) emailMessage = <p className={styles.emailError}>One or more email addresses are not formatted correctly</p>

  const emailComponent = (
    <div className={styles.email}>
      <div className={styles.emailInputContainer}>
        <input
          ref={enterEmailRef}
          className={styles.emailInput}
          value={emailInfo.emails}
          type="text"
          autoComplete="off"
          placeholder="Enter email address"
          onKeyUp={e => (e.key === 'Enter' || e.key === 'NumpadEnter') ? onEmailSubmit() : null }
          onBlur={() => {
            setEmailInfo({ ...emailInfo, isFocused: false })
          }}
          onFocus={() => {
            setEmailInfo({ ...emailInfo, isFocused: true, isValid: true })
          }}
          onChange={e => setEmailInfo({ ...emailInfo, emails: e.target.value })}
        />
        {emailAccessory}
      </div>
      {emailMessage}
    </div>
  )
  return emailComponent
}

EmailReceipt.defaultProps = {
  order: {},
}

EmailReceipt.propTypes = {
  order: PropTypes.object,
}

export default EmailReceipt
